/**
 * WordPress dependencies
 */
import { InnerBlocks } from '@wordpress/block-editor'
import {
	PanelBody, ToggleControl, RangeControl, TextControl
} from '@wordpress/components'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import {
	range,
} from '~cartzillagb/util'
import {
	select, dispatch
} from '@wordpress/data'
import { createBlock } from '@wordpress/blocks'

/**
 * External dependencies
 */
import classnames from 'classnames'
import { i18n } from 'cartzillagb'
import { withTabbedInspector, withUniqueClass } from '~cartzillagb/higher-order'
import memoize from "memize"
import times from "lodash/times"



addFilter( 'cartzillagb.columns.edit.inspector.style.before', 'cartzillagb/columns', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		limit,
		rowClass,
		enableContainer,
		enableGutter,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true     }>
				<RangeControl
					label={ __( 'No Of Columns', i18n ) }
					value={ limit }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.columns.edit.inspector.max.limit', 12 ) }
				/>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Gutter Space', i18n ) }
					checked={ enableGutter }
					onChange={ enableGutter => setAttributes( { enableGutter } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Additional Row Class Settings", i18n ) } initialOpen={ true     }>
				<TextControl
					label={ __('Additional Row Class', i18n ) }
					value={ rowClass }
					onChange={ rowClass => setAttributes( { rowClass } ) }
				/>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const {
		className, attributes,clientId
	} = props

	const {
		limit,
		rowClass,
		enableContainer,
		enableGutter,
	} = attributes

	const mainClasses = classnames( [
		'czgb-columns-block',
		className,
	], applyFilters( 'cartzillagb.columns.main-block.classes', {
		'container' : enableContainer,
	}, props ) )

	const allowedBlocks = [ 'czgb/column' ]

	const columnTemplate = range( 1, limit + 1 ).map( () => [ 'czgb/column' ] )

	if ( select('core/block-editor').getBlockCount() > 0 ) {
		const currentInnerBlocks = select( 'core/block-editor' ).getBlock( props.clientId ).innerBlocks
		const newInnerBlocks = range( 1, limit + 1 ).map( i => {
			return currentInnerBlocks[ i - 1 ] || createBlock( 'czgb/column', {}, [] )
		} )

		// Replace the current list of inner blocks.
		dispatch( 'core/block-editor' ).replaceInnerBlocks( props.clientId, newInnerBlocks, false )
	}

	return (
		<div className={ mainClasses }>
			<div className={ classnames( [ 
					rowClass, 'czgb-columns-block__inner', 'row', enableGutter === false && 'no-gutters' ] ) }>
				<InnerBlocks
					template={ columnTemplate }
					templateLock="all"
					allowedBlocks={ allowedBlocks }
				/>
			</div>      
		</div>    
	)  
}

export default compose(
	withUniqueClass,
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
